/** @file The analysis list: one button per autorig fn, grouped (whole rig, skeleton, parts, animation). */
import type { AutorigFn } from '@pose2d/api/autorig/autorigFns';
import type { CatalogKey, Translate } from '@pose2d/i18n/types';
import { AUTORIG_ACTIONS } from './autorigActions.data';
import type { AutorigAction } from './autorigTypes';

const ACTIONS: readonly AutorigAction[] = AUTORIG_ACTIONS;
const GROUPS: readonly (readonly [AutorigAction['group'], CatalogKey])[] = [
  ['rig', 'autorig.groupRig'],
  ['skeleton', 'autorig.groupSkeleton'],
  ['parts', 'autorig.groupParts'],
  ['animate', 'autorig.groupAnimate'],
];

/** Props of AutorigActions. */
export interface AutorigActionsProps {
  t: Translate;
  fn: AutorigFn;
  onPick: (fn: AutorigFn) => void;
}

/** The chosen fn is pressed; each button's tooltip is the API fn name (what an agent would call). */
export function AutorigActions({ t, fn, onPick }: AutorigActionsProps) {
  return (
    <div className="autorig-actions">
      {GROUPS.map(([group, label]) => (
        <section key={group} className="autorig-group" aria-label={t(label)}>
          <h3>{t(label)}</h3>
          {ACTIONS.filter((a) => a.group === group).map((a) => (
            <button key={a.fn} type="button" className="autorig-action" aria-pressed={a.fn === fn} title={a.fn} onClick={() => { onPick(a.fn); }}>
              {t(a.label)}
            </button>
          ))}
        </section>
      ))}
    </div>
  );
}
